import * as React from 'react';

import Text from 'components/Text';

import './styles/ProgressLabel.scss';

type Props = {
  currentStep?: number;
  label?: string;
  steps?: number;
};

export default function ProgressLabel(props: Props) {
  let { currentStep, label, steps } = props;
  let text = label;

  if (!label && !currentStep) {
    return null;
  }

  if (currentStep && steps) {
    text = `Step ${currentStep} of ${steps}`;
  }

  return (
    <Text
      element="div"
      size="xxxxsmall"
      smallCaps={!!currentStep}
      weight="semibold"
      className="ProgressLabel">
      {text}
    </Text>
  );
}
